import classNames from 'classnames';
import PropTypes from 'prop-types';
import qs from 'qs';
import React from 'react';

const FacetItem = (props) => {
  const query = {
    ...props.queryString,
  };

  //Remove page param
  if (query.p) delete query.p;
  if (query.site) delete query.site;

  let isSelected = false;

  if (typeof query[props.Name] === 'string') {
    isSelected = query[props.Name] === props.Id.toString();
  }

  //Selects the "show all results" facet
  if (typeof query[props.Name] === 'undefined' && query.q?.length > 0) {
    isSelected = 'all' === props.Id.toString();
  }

  if (typeof query[props.Name] === 'object') {
    isSelected =
      query[props.Name].filter((key) => key === props.Id.toString()).length > 0;
  }

  const classes = classNames({
    'c-facets__item': true,
    [`c-facets__item--theme-${props.Id}`]: true,
    'c-facets__item--selected': isSelected,
  });

  const makeItemArray = (key, array) => {
    if (!array[key]) return [];
    if (typeof array[key] === 'string') {
      return array[key].split();
    }
    return array[key];
  };
  const handleChange = (e) => {
    query[props.Name] = makeItemArray(props.Name, query);
    // We push the name to the URL for the tracking function to get.
    query['categoryname'] = makeItemArray('categoryname', query);

    if (e.currentTarget.checked) {
      query[props.Name].push(props.Id);
      if (props.Name === 'category') {
        query['categoryname'].push(props.Text);
      }
    } else {
      query[props.Name] = query[props.Name].filter((key) => key !== props.Id);
      if (props.Name === 'category' && query.categoryname) {
        query['categoryname'] = query['categoryname'].filter(
          (key) => key !== props.Text
        );
      }
    }

    props.history.push({
      search: `?${qs.stringify(query, { indices: false })}`,
    });
  };

  const handleRadioButtonChange = () => {
    props.names.forEach((name) => delete query[name]);
    query[props.Name] = props.Id;

    props.history.push({
      search: `?${qs.stringify(query, { indices: false })}`,
    });
  };

  return (
    <label className={classes}>
      <input
        className="c-facets__item__checkbox"
        type="checkbox"
        defaultChecked={isSelected}
        name={props.Name}
        value={props.Id}
        onChange={(e) =>
          props.FacetsRadioButton ? handleRadioButtonChange(e) : handleChange(e)
        }
      />
      <span className="c-facets__item__label">{props.Text}</span>
      {props.showCount && (
        <span className="c-facets__item__count">({props.count})</span>
      )}
    </label>
  );
};

const FacetsItems = ({
  names,
  history,
  Facets,
  queryString,
  pathname,
  FacetsRadioButton,
  facetCounts,
  showCount,
}) =>
  Facets.map((item, index) => (
    <FacetItem
      key={index}
      names={names}
      {...item}
      history={history}
      queryString={queryString}
      pathname={pathname}
      FacetsRadioButton={FacetsRadioButton}
      count={facetCounts?.[item?.Id] ?? 0}
      showCount={showCount}
    />
  ));

const Facets = ({
  history,
  Facets,
  queryString = [],
  pathname,
  FacetsRadioButton,
}) => {
  if (Facets.Items.length === 0) return null;

  const Names = Facets.Items.reduce((acc, cur) => {
    cur.Facets.forEach((item) => {
      if (!acc.some((i) => i === item.Name)) {
        acc.push(item.Name);
      }
    });

    return acc;
  }, []);

  const items = Facets.Items.map((item, index) => {
    if (item.Facets.length === 0) return null;

    return (
      <div className="c-facets__items" key={index}>
        {item.Heading && <h2 className="c-facets__heading">{item.Heading}</h2>}
        <FacetsItems
          {...item}
          names={Names}
          history={history}
          queryString={queryString}
          pathname={pathname}
          FacetsRadioButton={FacetsRadioButton}
        />
      </div>
    );
  });

  return (
    <div className="c-facets">
      <div className="c-facets__inner">{items}</div>
    </div>
  );
};

Facets.propTypes = {
  /** React router history object **/
  history: PropTypes.object,
  /** (BE) */
  Facets: PropTypes.shape({
    Items: PropTypes.arrayOf(
      PropTypes.shape({
        /** We also recieve a "Checked=false" property that is not used on Facets object. */
        Facets: PropTypes.arrayOf(
          PropTypes.shape({
            Name: PropTypes.string,
            Id: PropTypes.string,
            Text: PropTypes.string,
          })
        ),
        Heading: PropTypes.string,
      })
    ),
    ErrorMessage: PropTypes.string,
  }),
  queryString: PropTypes.object,
  pathname: PropTypes.string /** is this used? */,
  /** (BE) */
  FacetsRadioButton: PropTypes.bool,
};

export default Facets;
